import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="grid place-items-center min-h-[60vh]">
        <div className="text-sm text-[hsl(var(--muted-foreground))]">Carregando…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/entrar" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}
